import { Grid, List, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { messages } from './Acknowledge.messages';

export const Acknowledge = memo(() => {
    return (
        <Grid gap={16}>
            <Text font='body' fontSize='medium' fontWeight='regular'>
                {messages.byConfirming}
            </Text>

            <List removeLastSpacing listStyle='inside' spacing='16 0'>
                <List.Item>{messages.certify}</List.Item>

                <List.Item>{messages.agree}</List.Item>

                <List.Item>{messages.confirm}</List.Item>
            </List>
        </Grid>
    );
});

Acknowledge.displayName = 'Acknowledge';
